import { dashboardConstants } from "../_constants";

export const dashboardAccountListRequest = (payload) => {
  return {
    type: dashboardConstants.DASHBOARD_ACCOUNTS_LIST_REQUEST,
    payload,
  };
};

export const dashboardAccountListComplete = (payload) => {
  return {
    type: dashboardConstants.DASHBOARD_ACCOUNTS_LIST_SUCCESS,
    payload,
  };
};

export const dashboardAccountListsError = (payload) => {
  return {
    type: dashboardConstants.DASHBOARD_ACCOUNTS_LIST_ERROR,
    payload,
  };
};

export const dashboardBannerListRequest = (payload) => {
  return {
    type: dashboardConstants.DASHBOARD_BANNER_LIST_REQUEST,
    payload,
  };
};

export const dashboardBannerListComplete = (payload) => {
  return {
    type: dashboardConstants.DASHBOARD_BANNER_LIST_SUCCESS,
    payload,
  };
};

export const dashboardBannerListsError = (payload) => {
  return {
    type: dashboardConstants.DASHBOARD_BANNER_LIST_ERROR,
    payload,
  };
};

export const dashboardAccountHistoryListRequest = (payload) => {
  return {
    type: dashboardConstants.DASHBOARD_ACCOUNT_HISTORY_LIST_REQUEST,
    payload,
  };
};

export const dashboardAccountHistoryListComplete = (payload) => {
  return {
    type: dashboardConstants.DASHBOARD_ACCOUNT_HISTORY_LIST_COMPLETE,
    payload,
  };
};

export const dashboardAccountHistoryListError = (payload) => {
  return {
    type: dashboardConstants.DASHBOARD_ACCOUNT_HISTORY_LIST_ERROR,
    payload,
  };
};

export const dashboardSecureMailNotificationRequest = (payload) => {
  return {
    type: dashboardConstants.DASHBOARD_SECURE_MAIL_NOTIFICATION_REQUEST,
    payload,
  };
};

export const dashboardSecureMailNotificationComplete = (payload) => {
  return {
    type: dashboardConstants.DASHBOARD_SECURE_MAIL_NOTIFICATION_SUCCESS,
    payload,
  };
};

export const dashboardSecureMailNotificationError = (payload) => {
  return {
    type: dashboardConstants.DASHBOARD_SECURE_MAIL_NOTIFICATION_ERROR,
    payload,
  };
};

export const dashboardSecureMailNotificationClear = () => {
  return {
    type: dashboardConstants.DASHBOARD_SECURE_MAIL_NOTIFICATION_CLEAR,
  };
};

export const dashboardClearAccountHistoryList = (payload) => {
  return {
    type: dashboardConstants.DASHBOARD_CLEAR_ACCOUNT_HISTORY_LIST,
    payload,
  };
};
